export default class CollapseLongContent extends HTMLElement {

    connectedCallback() {
        this.linesMax = parseInt(this.getAttribute('lines-max')) || 4;
        this.render();
        this.checkContentHeight();
        window.addEventListener('resize', () => this.checkContentHeight());
    }

    render() {
        const content = this.innerHTML;
        this.innerHTML = `
            <div class="content">${content}</div>
            <a href="#myTab" class="toggle link text-underline" style="display: none;">Lire la suite</a>
        `;
        this.classList.add('collapsed');
        this.style.setProperty('--lines-max', this.linesMax);
    }

    checkContentHeight() {
        const content = this.querySelector('.content');
        const toggle = this.querySelector('.toggle');
        const lineHeight = parseInt(window.getComputedStyle(content).lineHeight);
        const maxHeight = lineHeight * this.linesMax;

        if (content.scrollHeight > maxHeight) {
            toggle.style.display = 'inline-block';
            this.setupEventListeners();
        } else {
            toggle.style.display = 'none';
        }
    }

    setupEventListeners() {
        const toggle = this.querySelector('.toggle');
        if (!toggle.hasListener) {
            toggle.hasListener = true;
        }
    }
}
